/**
 * BigQuery analytics for mark-as-completed header modals.
 * @module headerModals/utils/fireMarkAsCompletedAnalytics
 */

import { getAllJCodesFromAuthOnFile } from "../../../utils/existingDocsToLs";
import { logMarkAsCompletedButtonSaved } from "../../../utils/headerEventLogger";
import { FireMarkAsCompletedAnalyticsParams } from "../types";

/**
 * Logs the mark-as-completed BigQuery event and per-J-code status events.
 *
 * @param params - Order context, user, modal name, and J-code event logger
 */
export const fireMarkAsCompletedAnalytics = (
  params: FireMarkAsCompletedAnalyticsParams,
): void => {
  logMarkAsCompletedButtonSaved({
    generalOrderDetails: params.generalOrderDetails,
    authOnFile: params.authOnFile,
    coverageDetails: params.coverageDetails,
    user: params.user,
    oldAuthStatus: params.oldAuthStatus,
    modalName: params.modalName,
  });

  const allJCodes = getAllJCodesFromAuthOnFile(params.authOnFile ?? undefined);
  if (allJCodes) {
    params.logJCodeStatusEvents(allJCodes, 1000);
  }
};
